import Nullstack from 'nullstack';
export default function IconFlagOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-flag-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M5 5v16"
  }), "   ", Nullstack.element("path", {
    d: "M19 5v9"
  }), "   ", Nullstack.element("path", {
    d: "M7.641 3.645a4.994 4.994 0 0 1 4.359 1.355a5 5 0 0 0 7 0"
  }), "   ", Nullstack.element("path", {
    d: "M5 14a5 5 0 0 1 7 0a4.984 4.984 0 0 0 3.437 1.429m3.019 -.966c.19 -.14 .371 -.294 .544 -.463"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}